import * as React from 'react'

import type { Omit } from '../_helpers/utils'
import type { NotOverridableProps, PureDateInputProps } from '../_shared/PureDateInput'

import { ModalWrapper } from './ModalWrapper'
import type { ModalWrapperProps } from './ModalWrapper'

export type WrapperVariant = 'dialog'

export interface WrapperProps<T> {
  open: boolean
  onAccept: () => void
  onDismiss: () => void
  onClear: () => void
  onSetToday: () => void
  InputComponent: React.FunctionComponent<T>
  DateInputProps: T
  wider?: boolean
  showTabs?: boolean
}

type OmitInnerWrapperProps<T extends WrapperProps<any>> = Omit<T, keyof WrapperProps<any> | 'showTabs'>

export type ModalRoot = OmitInnerWrapperProps<ModalWrapperProps>

// prettier-ignore
export type ExtendWrapper<TInput extends PureDateInputProps > = {
  /**
   * Picker container option
   * @default 'dialog'
   */
  variant?: WrapperVariant
} & ModalRoot
  & Omit<TInput, NotOverridableProps>

export function getWrapperFromVariant<T>(): React.ComponentType<ModalWrapperProps<T>> {
  return ModalWrapper as any
}

type Props<T> = {
  variant?: WrapperVariant
  children?: React.ReactNode
} & ModalWrapperProps<T>

export const VariantContext = React.createContext<WrapperVariant | null>(null)

export const Wrapper: <T extends PureDateInputProps>(p: Props<T>) => React.ReactElement<Props<T>> = ({ ...props }) => {
  const Component = getWrapperFromVariant<typeof props.DateInputProps>()

  return (
    <VariantContext.Provider value={'dialog'}>
      <Component {...props} />
    </VariantContext.Provider>
  )
}
